angular.module("avant.autocomplete")
  .directive("autocompleteList", ["$compile", "$timeout", ($compile, $timeout, $templateCache) ->
    keyCodes =
      enter: 13
      escape: 27
      upArrow: 38
      downArrow: 40
      tab: 9
      space: 32

    rawTemplate = """
      <div ng-show="isOpen" class="autocomplete js-autocomplete" id="autocomplete">
        <ul class="autocomplete-list js-autocomplete-list list-group" ng-show="canShowList()">
          <li class="autocomplete-item js-autocomplete-item list-group-item"
              autocomplete-item
              ng-repeat="item in items track by $index"
              ng-class="{ 'autocomplete-item active js-autocomplete-item-selected': isActiveItem($index) }">
          </li>
        </ul>
        <div class="autocomplete-error js-autocomplete-error" ng-show="canShowErrors()">{{ errorMessage }}</div>
      </div>
    """
    restrict: "A"
    require: "ngModel"
    scope:
      autocompleteFetch: "&"
      autocompleteItemCallback: "&"
      autocompleteTemplateUrl: "@?"
    link: (scope, $element, attrs, ngModelCtrl) ->
      
      scope.isOpen = false
      scope.traversalIndex = 0
      scope.selectActiveItem = ->
        activeItem = scope.getActiveItem()

        selectItem(activeItem)
        scope.autocompleteItemCallback(item: activeItem)

      scope.getActiveItem = ->
        scope.items[scope.traversalIndex]

      scope.setActiveItem = (index) ->
        scope.traversalIndex = index

      scope.isActiveItem = (index) ->
        index is scope.traversalIndex

      scope.dismissPopover = ->
        closeList()
        resetTraversal()

      scope.canShowList = ->
        hasItems()

      scope.canShowErrors = ->
        scope.isOpen &&
        hasErrors &&
        isPopulated()

      getItemsFn = ->
        scope.autocompleteFetch()
          .then (items) ->
            scope.items = items

          .catch (reason) ->
            clearList()
            showErrors()

            scope.errorMessage = reason

      getItemsTimeoutFn = null

      getItems = ->
        hideErrors()
        $timeout.cancel(getItemsTimeoutFn);
        getItemsTimeoutFn = $timeout(getItemsFn, 250)

      hasItems = ->
        scope.items?.length? and scope.items.length > 0

      openList = ->
        unless scope.isOpen
          scope.isOpen = true

      closeList = ->
        if scope.isOpen
          scope.isOpen = false

      clearList = ->
        scope.items = []

      traverseUpwards = ->
        if scope.traversalIndex > 0
          scope.traversalIndex = scope.traversalIndex -= 1
        else
          scope.traversalIndex = (scope.items.length - 1)

      traverseDownwards = ->
        if scope.traversalIndex < (scope.items.length - 1)
          scope.traversalIndex = scope.traversalIndex += 1
        else
          scope.traversalIndex = 0

      resetTraversal = ->
        scope.traversalIndex = 0

      parseItem = (item) ->
        if item[scope.itemKey]?
          item[scope.itemKey]
        else
          item

      selectItem = (item) ->
        parsedItem = parseItem(item)

        ngModelCtrl.$setViewValue(parsedItem)
        ngModelCtrl.$render()

      isEmpty = ->
        ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue)

      isPopulated = ->
        !isEmpty()

      hasErrors = false
      showErrors = ->
        hasErrors = true

      hideErrors = ->
        hasErrors = false

      $element.on "keydown", ($event) ->
        switch $event.keyCode
          when keyCodes.upArrow
            $event.preventDefault()

            if hasItems()
              if scope.isOpen
                traverseUpwards()
              else
                openList()

          when keyCodes.downArrow
            $event.preventDefault()

            if hasItems()
              if scope.isOpen
                traverseDownwards()
              else
                openList()

          when keyCodes.enter
            $event.preventDefault()

          when keyCodes.tab
            if scope.isOpen
              $event.preventDefault()
          when keyCodes.space
            if !scope.isOpen
              openList()

        scope.$apply()

      $element.on "keyup", ($event) ->
        switch $event.keyCode
          when keyCodes.enter, keyCodes.tab
            if scope.isOpen and hasItems()
              $event.preventDefault()

              scope.selectActiveItem()
              scope.dismissPopover()

          when keyCodes.escape
            $event.preventDefault()

            scope.dismissPopover()

        scope.$apply()

      $element.on "focus", ->
        if isPopulated() && !scope.canShowList()
          getItems()
        scope.$apply()

      $element.on "blur", ->
        closeList()
        scope.$apply()

      ngModelCtrl.$viewChangeListeners.push ->
        openList()

        if isPopulated()
          getItems()
          resetTraversal()
        else
          clearList()

      compiledElement = $compile(rawTemplate)(scope)
      $element.after(compiledElement)
  ])

